import React from 'react';
import classNames from 'classnames';

/**
 * Renders an icon.
 *
 * @return {ReactElement} The icon element.
 */
const Icon = ({ value, className, size, color, type, onClick, style, children }) => (
    <i
        className={classNames(
            className,
            'icon',
            'mdi',
            value ? `mdi-${value}` : undefined,
            size && `icon--${size}`,
            color && `icon--${color}`,
            type && `icon--${type}`,
        )}
        style={style}
        onClick={onClick}
    >
        {children}
    </i>
);
Icon.defaultProps = {
    children: null,
    className: null,
    color: null,
    onClick: null,
    size: null,
    style: null,
    type: null,
    value: null,
};

export { Icon };
